import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {getExistingLogins} from 'web-app/react/login/helpers';
import * as Sentry from 'web-app/services/sentry';

export const fetchAccountsForLogin = deviceId => {
    if (deviceId === null) {
        const existingLogins = getExistingLogins();

        Sentry.captureMessage('[FBS-7135] deviceId is null', {
            extra: existingLogins,
        });
    }

    return RESTClient.getAuthenticatedObservable(`v2/devices/${deviceId}/logins`).map(accounts => ({
        accounts: List(accounts),
    }));
};
